import React, { lazy, Suspense } from "react";
const LazyListAgent = lazy(() => import("./ListAgent"));
const LazyEditAgent = lazy(() => import("./EditAgent"));
const LazyPrintListAgent = lazy(() => import("./PrintListAgent"));
const LazyPrintListBranch = lazy(() => import("./PrintListBranch"));

export const ListAgent = () => (
  <Suspense fallback="loading...">
    <LazyListAgent />
  </Suspense>
);
export const EditAgent = () => (
  <Suspense fallback="loading...">
    <LazyEditAgent />
  </Suspense>
);
export const PrintListAgent = () => (
  <Suspense fallback="loading...">
    <LazyPrintListAgent />
  </Suspense>
);
export const PrintListBranch = () => (
  <Suspense fallback="loading...">
    <LazyPrintListBranch />
  </Suspense>
);
